/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{display:flex;justify-content:space-between}.alert[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:0}table[_ngcontent-%COMP%]{font-size:14px}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]{vertical-align:top}.revolut-button[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:13px;float:left;margin-right:6px}"];
export { styles as styles };
